import { PointRowComponent } from './point-row/point-row.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ScoreListPage } from './score-list.page';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PointRowComponent
    ],
    declarations: [
        ScoreListPage,
    ],
    exports: [
        ScoreListPage
    ]
})
export class ScoreListPageModule { }
